// extracted by mini-css-extract-plugin
export default {"customLabel":"reactSelect_customLabel__jbRop","fontSize":"reactSelect_fontSize__RHPEY"};